import { FC, memo } from 'react'
import Dropzone from 'react-dropzone'

import { TableDataQa } from 'commons/types/enums'
import { IconName } from 'ui/components/Icon'

import { OutlineButton } from '../../../Buttons'
import { Dialog, DialogFace, DialogFooterActions } from '../../../Dialog'
import { FileSelectorDialogProps } from './FileSelectorDialogProps'
import { columns } from './columns'
import { useComponentEssence } from './hooks'

import { ActionRow, ButtonSPart, FilesTable } from './styles'

export const FileSelectorDialog: FC<FileSelectorDialogProps> = memo((props) => {
  const { title, onClose, initialFiles, onSubmit, showDialogAfterConfirm, showSpinner } = props
  const { files, addFiles, deleteFile, submitHandler } = useComponentEssence({
    initialFiles,
    onSubmit,
    onClose,
    showDialogAfterConfirm
  })

  return (
    <Dialog
      id="file-selector-dialog"
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title={title}
      headerActions={
        <ActionRow>
          <Dropzone multiple onDrop={addFiles}>
            {({ getRootProps, getInputProps }) => (
              <span {...getRootProps()} tabIndex={-1}>
                <input {...getInputProps()} />
                {
                  // This hack because we have (s) and style in button about text-transform
                  // in this case text looks like Add File(S) - S is too big
                }
                <OutlineButton face="brand" size="middle" icon={IconName.UPLOAD}>
                  Add file<ButtonSPart>(s)</ButtonSPart>
                </OutlineButton>
              </span>
            )}
          </Dropzone>
        </ActionRow>
      }
      onSubmit={submitHandler}
      isSubmitting={showSpinner}
      footerActions={[DialogFooterActions.SUBMIT]}
    >
      <FilesTable
        dataQa={TableDataQa.FILES_SELECTOR_LIST}
        columns={columns(deleteFile)}
        dataSource={files.map((el) => ({
          item: el
        }))}
        loading={showSpinner}
      />
    </Dialog>
  )
})
